const SUPPORTED_TAGS = ['INPUT', 'TEXTAREA'];
const SELECTOR = SUPPORTED_TAGS.join(',');
const getValidationState = el => {
  const message = el.validationMessage;
  const valid = el.checkValidity();
  if (valid) {
    return valid;
  }
  return message ? {
    message,
    valid
  } : valid;
};

/**
 * Checks validation state coming from the DOM. This is primarily to target things like input[type="date"] and similar
 * elements. The date input for example, we only get onChange with a complete date value or an empty value. So outside
 * of this validator check, if the date field was optional, the form would consider a partially filled date field as
 * valid because as far as the form is concerned, the field is still empty. So this validator uses the javascript
 * validation api to check for validation messages on the DOM.
 * @param ref
 */
function nativeValidator(ref) {
  return Object.freeze({
    message: null,
    callback: () => {
      if (!ref || !ref.current) {
        return true;
      }
      if (SUPPORTED_TAGS.indexOf(ref.current.tagName) >= 0) {
        return getValidationState(ref.current);
      }
      for (const el of ref.current.querySelectorAll(SELECTOR)) {
        const result = getValidationState(el);
        if (result === false || (result === null || result === void 0 ? void 0 : result.valid) === false) {
          return result;
        }
      }
      return true;
    }
  });
}
export default nativeValidator;